import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, RouteName } from '@mews-commander/enums';
import { ChangeBillingDetails } from '@mews-commander/modules/src/modules/billing';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => <ChangeBillingDetails billId={Route.useParams().billId} />;

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Bill/ChangeAddress/$billId')({
    beforeLoad: ({ context: { checkFeatureFlag, checkPrivilege } }) => {
        checkFeatureFlag(FeatureFlag.closedBillAddressChangeEnabled);
        checkPrivilege('manageAccounts');
        checkPrivilege('manageReservations');
        checkPrivilege('rebateItems');
        checkPrivilege('issueInvoices');
    },
    component: Component,
    staticData: {
        routeName: RouteName.BillChangeAddress,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});
